import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/platform/auth/auth-context';
import { UserSessionProvider } from '@/platform/auth/user-session-context';
import { Toaster } from '@/platform/ui/toaster';
import { VersionRefreshWidget } from '@/platform/ui/version-refresh-widget';
import { GlobalThemeLoader } from '@/platform/hooks/use-theme-settings';
import { AppRoutes } from './routes';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UserSessionProvider>
          <GlobalThemeLoader />
          <AppRoutes />
          <Toaster />
          <VersionRefreshWidget />
        </UserSessionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
